import { IAccountsPayableOpo } from "@nkr/models/reports";
import { DropdownButton, MenuItem } from "react-bootstrap";

type TProps = {
    ap: IAccountsPayableOpo
    onUpdateAchInfo: (ap: IAccountsPayableOpo) => void
};

export default function ActionsButtonOpo({ ap, onUpdateAchInfo }: TProps) {
    const enableUpdateACH = (ap.compAchRoutingNumber && ap.compAchRoutingNumber !== ap.achRoutingNumber)
        || (ap.compAchAccountNumber && ap.compAchAccountNumber !== ap.achAccountNumber);

    return (
        <DropdownButton title="Actions" bsSize="xs" bsStyle="primary" id={`opo-actions-${ap.opoId}`} pullRight>
            <MenuItem disabled={!enableUpdateACH} onClick={() => onUpdateAchInfo(ap)}>Update ACH Information</MenuItem>
        </DropdownButton>
    );
}
